import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const CreateForm = React.lazy(() => import('./CreateForm'));
const Table = React.lazy(() => import('./TenentTable'));
const PendingTable = React.lazy(() => import('./TenentTable/pending'));
const DetailPage = React.lazy(() => import('./DetailPage'));
const EditPage = React.lazy(() => import('./EditPage'));
const ActionPage = React.lazy(() => import('./EditPage/pending'));

export const onBordTenentConfigs = [
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/onboard-tenant/create',
    element: <CreateForm />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/superadmin/table',
    element: <Table />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/onboard-tenant/pending-list',
    element: <PendingTable />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/onboard-tenant/detail-page/:id',
    element: <DetailPage />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/onboard-tenant/edit-page/:id',
    element: <EditPage />,
  },
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/onboard-tenant/action/:id',
    element: <ActionPage />,
  },
];
